import { apiGet, apiPost } from "./client.js";
import type { User } from "./types.js";

export interface MagicLinkResponse {
  ok: boolean;
  message: string;
  expiresAt: string;
}

export interface VerifyResponse {
  ok: boolean;
  userId: string;
  isNew: boolean;
}

export function requestMagicLink(email: string): Promise<MagicLinkResponse> {
  return apiPost<MagicLinkResponse>("/auth/magic-link", { email });
}

export function verifyMagicLink(token: string): Promise<VerifyResponse> {
  return apiPost<VerifyResponse>("/auth/verify", { token });
}

export function logout(): Promise<void> {
  return apiPost<void>("/auth/logout", {});
}

export function getCurrentUser(): Promise<User> {
  return apiGet<User>("/auth/me");
}
